<template>
  <div class="baiduQueue">
    <div class="fromClass2">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item label="贷款人姓名">
          <el-input v-model="searchData.name"></el-input>
        </el-form-item>
        <el-form-item label="贷款人联系电话">
          <el-input v-model="searchData.tel"></el-input>
        </el-form-item>
        <el-form-item label="贷后管理人员">
          <el-select v-model="searchData.managerAdminId" clearable>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in allManagerList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="贷款类型">
          <el-select v-model="searchData.loanType" clearable>
            <el-option label="房屋抵押" value="房屋抵押"></el-option>
            <el-option label="信用贷款" value="信用贷款"></el-option>
            <el-option label="小微企业贷款" value="小微企业贷款"></el-option>
            <el-option label="汽车贷款" value="汽车贷款"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最近">
          <el-input v-model="searchData.needRepayment">
            <template slot="append">天内还款</template>
          </el-input>
        </el-form-item>
        <el-form-item label="最近">
          <el-input v-model="searchData.needDue">
            <template slot="append">天内到期</template>
          </el-input>
        </el-form-item>
        <el-form-item label="放款日期">
          <el-date-picker
            v-model="searchData.startGetDay"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="-">
          <el-date-picker
            v-model="searchData.endGetDay"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="跟进次数">
          <el-input v-model="searchData.followUpTimes"></el-input>
        </el-form-item>
        <el-form-item label="意向度">
          <el-select v-model="searchData.intentionLevel" clearable>
            <el-option label="未知" :value="0"></el-option>
            <el-option label="无意向" :value="1"></el-option>
            <el-option label="待进一步了解" :value="2"></el-option>
            <el-option label="考虑中" :value="3"></el-option>
            <el-option label="意向度高" :value="4"></el-option>
            <el-option label="暂时无法处理" :value="7"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn">
      <div>
        <el-button-group>
          <el-button type="primary" size="small" @click="add"
            >录入征信</el-button
          >
        </el-button-group>
      </div>
      <div>
        <el-button-group>
          <el-button type="primary" size="small" @click="derive"
            >导出</el-button
          >
          <el-button type="primary" size="small" @click="refresh"
            >查询</el-button
          >
        </el-button-group>
      </div>
    </div>
    <div class="tableClass">
      <template>
        <el-table
          ref="multipleTable"
          :data="list.list"
          tooltip-effect="dark"
          style="width: 100%"
          size="small"
          border
          stripe
          :cell-class-name="rowClassName"
          :header-cell-style="{ background: '#545c64', color: '#fff' }"
        >
          <el-table-column label="放款单号">
            <template slot-scope="scope">
              <div>{{ scope.row.order_no }}</div>
            </template>
          </el-table-column>
          <el-table-column label="贷款申请单号">
            <template slot-scope="scope">
              {{ scope.row.loan_order_no }}
            </template>
          </el-table-column>
          <el-table-column label="贷款人姓名">
            <template slot-scope="scope">
              {{ scope.row.customer_name }}
            </template>
          </el-table-column>
          <el-table-column label="贷款人电话">
            <template slot-scope="scope">
              {{ scope.row.customer_tel }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="性别">
            <template slot-scope="scope">
              {{scope.row.customer_name}}
            </template>
          </el-table-column> -->
          <el-table-column label="贷款类型">
            <template slot-scope="scope">
              {{ scope.row.loan_type }}
            </template>
          </el-table-column>
          <el-table-column label="贷款金额">
            <template slot-scope="scope">
              {{ scope.row.money }}
            </template>
          </el-table-column>
          <el-table-column label="放款日期">
            <template slot-scope="scope">
              {{ scope.row.get_day }}
            </template>
          </el-table-column>
          <el-table-column label="到期日期">
            <template slot-scope="scope">
              {{ scope.row.due_date }}
            </template>
          </el-table-column>
          <el-table-column label="到期提醒最近记录">
            <template slot-scope="scope">
              {{ scope.row.dueRemind }}
            </template>
          </el-table-column>
          <el-table-column label="还款提醒最近记录">
            <template slot-scope="scope">
              {{ scope.row.repaymentRemind }}
            </template>
          </el-table-column>
          <el-table-column label="操作员">
            <template slot-scope="scope">
              {{ scope.row.createAdmin }}
            </template>
          </el-table-column>
          <el-table-column label="贷后管理人员">
            <template slot-scope="scope">
              {{ scope.row.managerAdmin }}
            </template>
          </el-table-column>
          <el-table-column label="下次还款时间">
            <template slot-scope="scope">
              {{ scope.row.next_repayment_date }}
            </template>
          </el-table-column>
          <el-table-column label="跟进次数">
            <template slot-scope="scope">
              {{ scope.row.follow_up_times }}
            </template>
          </el-table-column>
          <el-table-column label="跟进意向">
            <template slot-scope="scope">
              {{ scope.row.intention_level }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="240" fixed="right">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="viewDetail(scope.row, true)"
                  >查看详情</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="viewDetail(scope.row, false)"
                  >编辑放款信息</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="setManager(scope.row)"
                  >设置贷后管理人员</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="remind(scope.row, 1)"
                  v-if="scope.row.canRemind == 1"
                  >还款提醒</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="remind(scope.row, 2)"
                  v-if="scope.row.canRemind == 1"
                  >到期提醒</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="remindLog(scope.row)"
                  >查看提醒记录</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="getLoanOrderInfo(scope.row, true)"
                  >查看贷款单</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="followUp(scope.row)"
                  >跟进</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="followUpRecord(scope.row, true)"
                  >跟进记录</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteData(scope.row)"
                  >删除放款信息</el-button
                >
                <!-- <el-button
                  type="warning"
                  size="mini"
                  @click="deleteData2(scope.row)"
                >删除放款信息</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="1"
          :page-sizes="[10, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.totalRow"
          size="small"
        ></el-pagination>
      </template>
    </div>
    <el-dialog
      title="跟进"
      :visible.sync="followUpShow"
      width="700px"
      :before-close="handleClose"
    >
      <el-form
        :model="followUpData"
        :rules="rules"
        ref="followUpData"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="意向度" prop="intentionLevel">
          <el-select v-model="followUpData.intentionLevel">
            <el-option label="未知" :value="0"></el-option>
            <el-option label="无意向" :value="1"></el-option>
            <el-option label="待进一步了解" :value="2"></el-option>
            <el-option label="考虑中" :value="3"></el-option>
            <el-option label="意向度高" :value="4"></el-option>
            <el-option label="空号" :value="5"></el-option>
            <el-option label="黑名单" :value="6"></el-option>
            <el-option label="暂时无法处理" :value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="followUpData.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="followUpSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="跟进记录"
      :visible.sync="followUpListShow"
      width="700px"
      :before-close="handleClose"
    >
      <el-table
        ref="multipleTable"
        :data="followUpListData"
        tooltip-effect="dark"
        style="width: 100%"
        size="small"
        border
        stripe
        :header-cell-style="{ background: '#545c64', color: '#fff' }"
      >
        <el-table-column label="跟进人员">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="意向度">
          <template slot-scope="scope">
            {{ scope.row.intentionLevel }}
          </template>
        </el-table-column>
        <el-table-column label="备注信息">
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column label="跟进时间">
          <template slot-scope="scope">
            {{ scope.row.time }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="设置贷后管理人员"
      :visible.sync="setManagerShow"
      width="500px"
      :before-close="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="贷后管理人员" prop="managerId">
          <el-select v-model="form.managerId" clearable>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in allManagerList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="setManagerSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="删除放款信息"
      :visible.sync="deleteDataShow"
      width="500px"
      :before-close="handleClose"
    >
      <el-form
        :model="deleteDataForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="登录密码">
          <el-input v-model="deleteDataForm.pwd"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="deleteDataSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="viewDetailType ? '查看详情' : `编辑放款信息`"
      :visible.sync="viewDetailShow"
      width="700px"
      :before-close="handleClose"
    >
      <el-form
        :model="detail"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
        :disabled="viewDetailType"
      >
        <el-form-item label="贷款类型">
          <el-select v-model="detail.loan_type" clearable>
            <el-option label="房屋抵押" value="房屋抵押"></el-option>
            <el-option label="信用贷款" value="信用贷款"></el-option>
            <el-option label="小微企业贷款" value="小微企业贷款"></el-option>
            <el-option label="汽车贷款" value="汽车贷款"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="放款机构">
          <el-input v-model="detail.loan_company"></el-input>
        </el-form-item>
        <el-form-item label="贷款金额">
          <el-input v-model="detail.money"></el-input>
        </el-form-item>
        <el-form-item label="贷款期限">
          <el-input v-model="detail.how_long"></el-input>
        </el-form-item>
        <el-form-item label="年利率">
          <el-input v-model="detail.year_interest"></el-input>
        </el-form-item>
        <el-form-item label="月利率">
          <el-input v-model="detail.month_interest"></el-input>
        </el-form-item>
        <el-form-item label="还款方式">
          <el-select v-model="detail.repayment_type" clearable>
            <el-option label="等额本息" value="等额本息"></el-option>
            <el-option label="先息后本" value="先息后本"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" v-if="detail.repayment_type == '其他'">
          <el-input v-model="detail.remark"></el-input>
        </el-form-item>
        <el-form-item label="放款日期">
          <el-date-picker
            v-model="detail.get_day"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="还款日">
          <!-- <el-input type="number" v-model="detail.repayment_day" ></el-input> -->
          <el-select v-model="detail.repayment_day" clearable>
            <el-option
              :label="item + '日'"
              :value="item + '日'"
              v-for="(item, index) in 31"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到期日期">
          <el-date-picker
            v-model="detail.due_date"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="viewDetailSubmit"
          v-if="!viewDetailType"
          >提 交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="添加放款信息"
      :visible.sync="viewDetailAddShow"
      width="700px"
      :before-close="handleClose"
    >
      <el-form
        :model="detailAdd"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="贷款单单号">
          <el-input v-model="detail.loanOrderNo"></el-input>
        </el-form-item>
        <el-form-item label="贷款类型">
          <el-select v-model="detail.loanType" clearable>
            <el-option label="房屋抵押" value="房屋抵押"></el-option>
            <el-option label="信用贷款" value="信用贷款"></el-option>
            <el-option label="小微企业贷款" value="小微企业贷款"></el-option>
            <el-option label="汽车贷款" value="汽车贷款"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="放款机构">
          <el-input v-model="detail.loanCompany"></el-input>
        </el-form-item>
        <el-form-item label="贷款金额">
          <el-input v-model="detail.money">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="贷款期限">
          <el-input v-model="detail.howLong">
            <template slot="append">期</template>
          </el-input>
        </el-form-item>
        <el-form-item label="年利率">
          <el-input v-model="detail.yearInterest"></el-input>
        </el-form-item>
        <el-form-item label="月利率">
          <el-input v-model="detail.monthInterest"></el-input>
        </el-form-item>
        <el-form-item label="还款方式">
          <el-select v-model="detail.repaymentType" clearable>
            <el-option label="等额本息" value="等额本息"></el-option>
            <el-option label="先息后本" value="先息后本"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" v-if="detail.repaymentType == '其他'">
          <el-input v-model="detail.remark"></el-input>
        </el-form-item>
        <el-form-item label="放款日期">
          <el-date-picker
            v-model="detail.getDay"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="还款日">
          <el-select v-model="detail.repaymentDay" clearable>
            <el-option
              :label="item + '日'"
              :value="item + '日'"
              v-for="(item, index) in 31"
              :key="index"
            ></el-option>
          </el-select>
          <!-- <el-input type="number" v-model="detail.repaymentDay" ></el-input> -->
        </el-form-item>
        <el-form-item label="到期日期">
          <el-date-picker
            v-model="detail.dueDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="viewDetailAddSubmit">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提醒记录"
      :visible.sync="remindLogShow"
      width="700px"
      :before-close="handleClose"
    >
      <el-table
        ref="multipleTable"
        :data="remindLogList"
        tooltip-effect="dark"
        style="width: 100%"
        size="small"
        border
        stripe
        :header-cell-style="{ background: '#545c64', color: '#fff' }"
      >
        <el-table-column label="操作人员">
          <template slot-scope="scope">
            {{ scope.row.admin }}
          </template>
        </el-table-column>
        <el-table-column label="提醒信息">
          <template slot-scope="scope">
            {{ scope.row.type }}
          </template>
        </el-table-column>
        <el-table-column label="操作时间">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="贷款单信息"
      :visible.sync="orderCreateShow"
      width="700px"
      :before-close="handleClose"
    >
      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="审核信息" name="review" v-if="orderCreateType">
          <el-form
            :model="orderCreateForm"
            :rules="orderCreateRules"
            ref="orderCreateRuleForm"
            label-width="100px"
            class="demo-ruleForm"
            :disabled="orderCreateType"
          >
            <el-form-item
              label="资方审核进度"
              prop="reviewProgress"
              v-if="orderCreateForm.state == 5"
            >
              <el-input v-model="orderCreateForm.reviewProgress"></el-input>
            </el-form-item>
            <el-form-item
              label="做单人员"
              prop="doOrderPerson"
              v-if="orderCreateForm.doOrderPerson"
            >
              <el-input v-model="orderCreateForm.doOrderPerson"></el-input>
            </el-form-item>
            <el-form-item
              label="录单人员"
              prop="salesman"
              v-if="orderCreateForm.salesman"
            >
              <el-input v-model="orderCreateForm.salesman"></el-input>
            </el-form-item>
            <el-form-item
              label="批款信息"
              prop="appropriations_message"
              v-if="orderCreateForm.appropriations_message"
            >
              <el-input
                v-model="orderCreateForm.appropriations_message"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="资方拒绝原因"
              prop="loan_company_reject_reason"
              v-if="orderCreateForm.loan_company_reject_reason"
            >
              <el-input
                v-model="orderCreateForm.loan_company_reject_reason"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="客户取消原因"
              prop="customer_give_up_reason"
              v-if="orderCreateForm.customer_give_up_reason"
            >
              <el-input
                v-model="orderCreateForm.customer_give_up_reason"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="基础信息" name="user">
          <el-form
            :model="orderCreateForm"
            :rules="orderCreateRules"
            ref="orderCreateRuleForm"
            label-width="100px"
            class="demo-ruleForm"
            :disabled="orderCreateType"
          >
            <el-form-item label="客户来源" prop="origin">
              <el-select v-model="orderCreateForm.origin" clearable>
                <el-option label="电销" value="电销"></el-option>
                <el-option label="转介绍" value="转介绍"></el-option>
                <el-option label="老客户" value="老客户"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="贷款类型" prop="loan_type">
              <el-select v-model="orderCreateForm.loan_type" clearable>
                <el-option label="房屋抵押" value="房屋抵押"></el-option>
                <el-option label="信用贷款" value="信用贷款"></el-option>
                <el-option
                  label="小微企业贷款"
                  value="小微企业贷款"
                ></el-option>
                <el-option label="汽车贷款" value="汽车贷款"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请金额" prop="apply_money">
              <el-input v-model="orderCreateForm.apply_money">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="客户姓名" prop="name">
              <el-input v-model="orderCreateForm.name"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="tel">
              <el-input v-model="orderCreateForm.tel"></el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="address">
              <el-input v-model="orderCreateForm.address"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="id_card">
              <el-input v-model="orderCreateForm.id_card"></el-input>
            </el-form-item>
            <el-form-item label="婚姻状况" prop="marital_status">
              <el-select v-model="orderCreateForm.marital_status" clearable>
                <el-option label="未婚" value="未婚"></el-option>
                <el-option label="已婚" value="已婚"></el-option>
                <el-option label="离异" value="离异"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户类型" prop="customer_type">
              <el-select v-model="orderCreateForm.customer_type" clearable>
                <el-option label="上班" value="上班"></el-option>
                <el-option label="做生意" value="做生意"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户的用途" prop="loan_using">
              <el-input v-model="orderCreateForm.loan_using"></el-input>
            </el-form-item>
            <el-form-item label="家人是否知晓" prop="family_know">
              <el-select v-model="orderCreateForm.family_know" clearable>
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户的要求" prop="need">
              <el-input v-model="orderCreateForm.need"></el-input>
            </el-form-item>
            <el-form-item label="联系人1姓名" prop="contacts1_name">
              <el-input v-model="orderCreateForm.contacts1_name"></el-input>
            </el-form-item>
            <el-form-item label="联系人1关系" prop="contacts1_relation">
              <el-select v-model="orderCreateForm.contacts1_relation" clearable>
                <el-option label="配偶" value="配偶"></el-option>
                <el-option label="亲属" value="亲属"></el-option>
                <el-option label="朋友" value="朋友"></el-option>
                <el-option label="同事" value="同事"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人1电话" prop="contacts1_tel">
              <el-input v-model="orderCreateForm.contacts1_tel"></el-input>
            </el-form-item>
            <el-form-item label="联系人2姓名" prop="contacts2_name">
              <el-input v-model="orderCreateForm.contacts2_name"></el-input>
            </el-form-item>
            <el-form-item label="联系人2关系" prop="contacts2_relation">
              <el-select v-model="orderCreateForm.contacts2_relation" clearable>
                <el-option label="配偶" value="配偶"></el-option>
                <el-option label="亲属" value="亲属"></el-option>
                <el-option label="朋友" value="朋友"></el-option>
                <el-option label="同事" value="同事"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人2电话" prop="contacts2_tel">
              <el-input v-model="orderCreateForm.contacts2_tel"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="工作信息" name="job">
          <el-form
            :model="orderCreateForm"
            :rules="orderCreateRules"
            ref="orderCreateRuleForm"
            label-width="150px"
            class="demo-ruleForm"
            :disabled="orderCreateType"
          >
            <el-form-item label="单位名称" prop="working_name">
              <el-input v-model="orderCreateForm.working_name"></el-input>
            </el-form-item>
            <el-form-item label="单位地址" prop="working_address">
              <el-input v-model="orderCreateForm.working_address"></el-input>
            </el-form-item>
            <el-form-item label="工作年限" prop="working_years">
              <el-input v-model="orderCreateForm.working_years"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="job_position">
              <el-select v-model="orderCreateForm.job_position" clearable>
                <el-option label="高级管理" value="高级管理"></el-option>
                <el-option label="中层管理" value="中层管理"></el-option>
                <el-option label="普通员工" value="普通员工"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年工资(个税显示为准)" prop="yearly_salary">
              <el-input v-model="orderCreateForm.yearly_salary"></el-input>
            </el-form-item>
            <el-form-item label="工资发放方式" prop="wage_pay_way">
              <el-select v-model="orderCreateForm.wage_pay_way" clearable>
                <el-option label="现金" value="现金"></el-option>
                <el-option label="代发" value="代发"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公积金基数" prop="gongjijin">
              <el-input v-model="orderCreateForm.gongjijin"></el-input>
            </el-form-item>
            <el-form-item label="社保基数" prop="shebao">
              <el-input v-model="orderCreateForm.shebao"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="公司信息" name="company">
          <el-form
            :model="orderCreateForm"
            :rules="orderCreateRules"
            ref="orderCreateRuleForm"
            label-width="150px"
            class="demo-ruleForm"
            :disabled="orderCreateType"
          >
            <el-form-item label="公司名称" prop="company_name">
              <el-input v-model="orderCreateForm.company_name"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="company_job">
              <el-select v-model="orderCreateForm.company_job" clearable>
                <el-option label="老板" value="老板"></el-option>
                <el-option label="法人代表" value="法人代表"></el-option>
                <el-option label="股东" value="股东"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公司类型" prop="company_type">
              <el-select v-model="orderCreateForm.company_type" clearable>
                <el-option label="个体户" value="个体户"></el-option>
                <el-option label="有限公司" value="有限公司"></el-option>
                <el-option label="个人独资" value="个人独资"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公司经营地址" prop="company_address">
              <el-input v-model="orderCreateForm.company_address"></el-input>
            </el-form-item>
            <el-form-item
              label="是否有真实经营场地"
              prop="company_has_true_address"
            >
              <el-select
                v-model="orderCreateForm.company_has_true_address"
                clearable
              >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="是否有银联收款码"
              prop="company_has_payment_code"
            >
              <el-select
                v-model="orderCreateForm.company_has_payment_code"
                clearable
              >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经营场地" prop="company_address_nature">
              <el-select
                v-model="orderCreateForm.company_address_nature"
                clearable
              >
                <el-option label="租用" value="租用"></el-option>
                <el-option label="自有财产" value="自有财产"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年营业额" prop="company_month_income">
              <el-input
                v-model="orderCreateForm.company_month_income"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否有开票纳税" prop="company_has_pay_taxes">
              <el-select
                v-model="orderCreateForm.company_has_pay_taxes"
                clearable
              >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="纳税等级" prop="company_pay_taxes_level">
              <el-select
                v-model="orderCreateForm.company_pay_taxes_level"
                clearable
              >
                <el-option label="A级" value="A"></el-option>
                <el-option label="B级" value="B"></el-option>
                <el-option label="M级" value="M"></el-option>
                <el-option label="C级" value="C"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="近1年开票金额"
              prop="company_year_invoice_money"
            >
              <el-input
                v-model="orderCreateForm.company_year_invoice_money"
              ></el-input>
            </el-form-item>
            <el-form-item label="近1年纳税金额" prop="company_year_taxes_money">
              <el-input
                v-model="orderCreateForm.company_year_taxes_money"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="房产信息" name="house">
          <el-form
            :model="orderCreateForm"
            :rules="orderCreateRules"
            ref="orderCreateRuleForm"
            label-width="100px"
            class="demo-ruleForm"
            :disabled="orderCreateType"
          >
            <el-form-item label="房产类型" prop="house_type">
              <el-select v-model="orderCreateForm.house_type" clearable>
                <el-option label="住宅" value="住宅"></el-option>
                <el-option label="公寓" value="公寓"></el-option>
                <el-option label="办公" value="办公"></el-option>
                <el-option label="商铺" value="商铺"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房产性质" prop="house_nature">
              <el-select v-model="orderCreateForm.house_nature" clearable>
                <el-option label="全款" value="全款"></el-option>
                <el-option label="按揭" value="按揭"></el-option>
                <el-option label="抵押" value="抵押"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房产所有权" prop="house_ownership">
              <el-select v-model="orderCreateForm.house_ownership" clearable>
                <el-option label="个人所有" value="个人所有"></el-option>
                <el-option label="夫妻共有" value="夫妻共有"></el-option>
                <el-option label="家人共有" value="家人共有"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房产地址" prop="house_address">
              <el-input v-model="orderCreateForm.house_address"></el-input>
            </el-form-item>
            <el-form-item label="楼盘名称" prop="lpmc">
              <el-input v-model="orderCreateForm.lpmc"></el-input>
            </el-form-item>
            <el-form-item label="建筑面积" prop="house_area">
              <el-input v-model="orderCreateForm.house_area"></el-input>
            </el-form-item>
            <el-form-item label="建筑年份" prop="house_year_built">
              <el-input v-model="orderCreateForm.house_year_built"></el-input>
            </el-form-item>
            <el-form-item
              label="抵押银行"
              prop="house_mortgage_to_bank"
              v-if="orderCreateForm.house_nature != '全款'"
            >
              <el-input
                v-model="orderCreateForm.house_mortgage_to_bank"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="抵押金额"
              prop="house_mortgage_money"
              v-if="orderCreateForm.house_nature != '全款'"
            >
              <el-input
                v-model="orderCreateForm.house_mortgage_money"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="抵押期限"
              prop="house_mortgage_long"
              v-if="orderCreateForm.house_nature != '全款'"
            >
              <el-input
                v-model="orderCreateForm.house_mortgage_long"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="每月还款" prop="house_month_return_money" v-if="orderCreateForm.house_nature=='按揭'">
              <el-input v-model="orderCreateForm.house_month_return_money" ></el-input>
            </el-form-item> -->
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="车辆信息" name="car">
          <el-form
            :model="orderCreateForm"
            :rules="orderCreateRules"
            ref="orderCreateRuleForm"
            label-width="100px"
            class="demo-ruleForm"
            :disabled="orderCreateType"
          >
            <el-form-item label="汽车品牌" prop="car_brand">
              <el-input v-model="orderCreateForm.car_brand"></el-input>
            </el-form-item>
            <el-form-item label="购买时间" prop="car_buy_time">
              <el-date-picker
                v-model="orderCreateForm.car_buy_time"
                type="month"
                value-format="yyyy-MM"
                format="yyyy-MM"
                placeholder=" "
              >
              </el-date-picker>
              <!-- <el-input v-model="orderCreateForm.car_buy_time" ></el-input> -->
            </el-form-item>
            <el-form-item label="车辆所有人" prop="car_ownership">
              <el-select v-model="orderCreateForm.car_ownership" clearable>
                <el-option label="本人" value="本人"></el-option>
                <el-option label="家人" value="家人"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="汽车性质" prop="car_nature">
              <el-select v-model="orderCreateForm.car_nature" clearable>
                <el-option label="全款" value="全款"></el-option>
                <el-option label="按揭" value="按揭"></el-option>
                <el-option label="抵押" value="抵押"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="行驶公里数" prop="car_ran_kilometers">
              <el-input v-model="orderCreateForm.car_ran_kilometers">
                <template slot="append">万公里</template>
              </el-input>
            </el-form-item>
            <el-form-item label="寿险保单" prop="car_has_commercial_insurance">
              <el-select
                v-model="orderCreateForm.car_has_commercial_insurance"
                clearable
              >
                <el-option label="有" value="有"></el-option>
                <el-option label="无" value="无"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="投保时间"
              prop="car_policy_holder"
              v-if="orderCreateForm.car_has_commercial_insurance == '有'"
            >
              <el-date-picker
                v-model="orderCreateForm.car_policy_holder"
                type="month"
                value-format="yyyy-MM"
                format="yyyy-MM"
                placeholder=" "
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="每年投保金额"
              prop="car_policy_company"
              v-if="orderCreateForm.car_has_commercial_insurance == '有'"
            >
              <el-input v-model="orderCreateForm.car_policy_company">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="征信信息" name="number">
          <el-form
            :model="orderCreateForm"
            :rules="orderCreateRules"
            ref="orderCreateRuleForm"
            label-width="120px"
            class="demo-ruleForm"
            :disabled="orderCreateType"
          >
            <el-form-item label="贷款笔数" prop="number_of_liabilities">
              <el-input
                v-model="orderCreateForm.number_of_liabilities"
              ></el-input>
            </el-form-item>
            <el-form-item label="贷款授信总额" prop="total_liabilities">
              <el-input v-model="orderCreateForm.total_liabilities"></el-input>
            </el-form-item>
            <el-form-item label="余额" prop="sxye">
              <el-input v-model="orderCreateForm.sxye"></el-input>
            </el-form-item>
            <el-form-item label="近半年平均还款额" prop="bnpjhke">
              <el-input v-model="orderCreateForm.bnpjhke"></el-input>
            </el-form-item>
            <el-form-item label="信用卡机构数" prop="bankcard_num">
              <el-input v-model="orderCreateForm.bankcard_num"></el-input>
            </el-form-item>
            <el-form-item label="信用卡授信总额" prop="total_bankcard_money">
              <el-input
                v-model="orderCreateForm.total_bankcard_money"
              ></el-input>
            </el-form-item>
            <el-form-item label="已用额度" prop="bankcard_overdraw_money">
              <el-input
                v-model="orderCreateForm.bankcard_overdraw_money"
              ></el-input>
            </el-form-item>
            <el-form-item label="近半年平均使用额" prop="month_return_money">
              <el-input v-model="orderCreateForm.month_return_money"></el-input>
            </el-form-item>
            <el-form-item
              label="征信最近3个月查询次数"
              prop="credit_check_times"
            >
              <el-input v-model="orderCreateForm.credit_check_times"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="附件信息" name="file">
          <el-form
            :model="orderCreateForm"
            :rules="orderCreateRules"
            ref="orderCreateRuleForm"
            label-width="100px"
            class="demo-ruleForm"
            :disabled="orderCreateType"
          >
            <el-form-item label="文件">
              <el-upload
                class="avatar-uploader"
                :action="'https://api.dscj2016.com/api/upload/index'"
                :show-file-list="false"
                :on-success="orderCreateFileSuccess"
                :before-upload="orderCreateFileUpload"
                name="file"
                multiple
                :headers="{ token: token || '' }"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="orderCreateForm.files.length">
              <el-tag
                v-for="(item, index) in orderCreateForm.files"
                :key="item"
                :closable="!orderCreateType"
                type="success"
                @close="deleteFile(index)"
                @click="xiazai(index)"
                style="cursor: pointer"
              >
                {{ item }}
              </el-tag>
            </el-form-item>

            <el-form-item label="图片">
              <el-upload
                class="avatar-uploader"
                :action="'https://api.dscj2016.com/api/upload/index'"
                :show-file-list="false"
                :on-success="orderCreateImageSuccess"
                :before-upload="orderCreateImageUpload"
                name="file"
                multiple
                :headers="{ token: token || '' }"
                accept="image/jpg,image/jpeg,image/png"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="orderCreateForm.images.length">
              <div style="display: flex">
                <div
                  style="
                    margin-right: 10px;
                    margin-bottom: 10px;
                    position: relative;
                  "
                  v-for="(item, index) in orderCreateForm.images"
                  :key="index"
                >
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item"
                    :preview-src-list="orderCreateForm.images"
                  >
                  </el-image>
                  <img
                    v-if="!orderCreateType"
                    @click="deleteImg(index)"
                    style="
                      position: absolute;
                      top: -10px;
                      right: -10px;
                      width: 20px;
                      height: 20px;
                      cursor: pointer;
                    "
                    src="/static/close2.png"
                  />
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="备注信息" name="qita">
          <el-form
            :model="orderCreateForm"
            :rules="orderCreateRules"
            ref="orderCreateRuleForm"
            label-width="100px"
            class="demo-ruleForm"
            :disabled="orderCreateType"
          >
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="orderCreateForm.remark"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="success"
          @click="orderCreateSubmit"
          v-if="!orderCreateType"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from "js-cookie";

export default {
  title: "课程列表",
  data() {
    return {
      token: "",
      accountType: "",
      roleType: "",
      page: 1,
      pageSize: 10,
      name: "",
      list: {},
      searchData: {
        name: "",
        tel: "",
        managerAdminId: "",
        loanType: "",
        needRepayment: "",
        needDue: "",
        endGetDay: "",
        startGetDay: "",
        followUpTimes: "",
        intentionLevel: "",
      },
      allManagerList: [],
      setManagerShow: false,
      form: {
        id: "",
        managerId: "",
      },
      deleteDataShow: false,
      deleteDataForm: {
        pwd: "",
        id: "",
      },
      rules: {
        managerId: [{ required: true, message: "请选择", trigger: "change" }],
        intentionLevel: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      viewDetailShow: false,
      viewDetailType: false,
      viewDetailAddShow: false,
      detailAdd: {
        loanOrderNo: "",
        loanType: "",
        loanCompany: "",
        money: "",
        howLong: "",
        yearInterest: "",
        monthInterest: "",
        repaymentType: "",
        getDay: "",
        repaymentDay: "",
        dueDate: "",
      },
      detail: {},
      remindLogShow: false,
      remindLogList: [],
      orderCreateForm: {
        customer_id: "",
        origin: "",
        loan_type: "",
        name: "",
        id_card: "",
        birthday: "",
        gender: "",
        tel: "",
        address: "",
        marital_status: "",
        customer_type: "",
        apply_money: "",
        loan_using: "",
        family_know: "",
        need: "",
        contacts1_name: "",
        contacts1_relation: "",
        contacts1_tel: "",
        contacts2_name: "",
        contacts2_relation: "",
        contacts2_tel: "",
        working_years: "",
        working_name: "",
        working_address: "",
        job_position: "",
        yearly_salary: "",
        wage_pay_way: "",
        gongjijin: "",
        shebao: "",
        house_type: "",
        house_nature: "",
        house_ownership: "",
        house_address: "",
        lpmc: "",
        house_area: "",
        house_year_built: "",
        house_mortgage_to_bank: "",
        house_mortgage_money: "",
        house_mortgage_long: "",
        house_month_return_money: "",
        car_brand: "",
        car_ownership: "",
        car_nature: "",
        car_ran_kilometers: "",
        car_has_commercial_insurance: "",
        car_policy_holder: "",
        car_policy_company: "",
        car_buy_time: "",
        number_of_liabilities: "",
        sxye: "",
        bnpjhke: "",
        total_liabilities: "",
        month_return_money: "",
        bankcard_num: "",
        total_bankcard_money: "",
        bankcard_overdraw_money: "",
        credit_check_times: "",
        company_name: "",
        company_job: "",
        company_type: "",
        company_address: "",
        company_has_true_address: "",
        company_has_payment_code: "",
        company_address_nature: "",
        company_month_income: "",
        company_has_pay_taxes: "",
        company_pay_taxes_level: "",
        company_year_invoice_money: "",
        company_year_taxes_money: "",
        files: [],
        images: [],
        remark: "",
      },
      orderCreateShow: false,
      orderCreateType: false,
      activeName: "user",
      orderCreateRules: {},
      followUpShow: false,
      followUpListShow: false,
      followUpListData: [],
      followUpData: {
        id: "",
        intentionLevel: "",
        remark: "",
      },
    };
  },
  computed: {},
  components: {},
  filters: {
    date1(e) {
      let date = new Date(e);
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds()
      );
    },
  },
  methods: {
    followUp(e) {
      this.followUpShow = true;
      this.followUpData.id = e.id;
    },
    followUpSubmit() {
      this.$refs["followUpData"].validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              "/api/loan_information/followUp",
              this.$qs.stringify(this.followUpData),
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: `跟进成功`,
                  type: "success",
                });
                this.getData();
                this.handleClose();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    followUpRecord(e) {
      this.$axios
        .post(
          "/api/loan_information/followUpRecord",
          this.$qs.stringify({ id: e.id }),
        )
        .then((res) => {
          if (res.data.code == 1) {
            // console.log(res)
            this.followUpListData = res.data.data;
            this.followUpListShow = true;
          }
        });
    },
    rowClassName(row, rowIndex) {
      // console.log(row.row.canRemind)
      if (row.row.canRemind == 0) {
        return "classRed";
      }
    },
    add() {
      this.viewDetailAddShow = true;
    },
    // 查看贷款单————————————————————————————————————————————————————————————————————————
    getLoanOrderInfo(e, index) {
      this.$axios
        .post(
          "/api/loan_information/getLoanOrderInfo",
          this.$qs.stringify({ id: e.id }),
        )
        .then((res) => {
          if (res.data.code == 1) {
            let order = res.data.data;
            order.images = JSON.parse(res.data.data.images);
            order.files = JSON.parse(res.data.data.files);
            this.orderCreateForm = order;
            this.orderCreateShow = true;
            this.orderCreateType = index;
            this.activeName = index ? "review" : "user";
          }
        });
    },
    orderCreateSubmit() {
      let form = { ...this.orderCreateForm };
      form.files = JSON.stringify(form.files);
      form.images = JSON.stringify(form.images);
      this.$axios
        .post("/api/loan_order/edit", this.$qs.stringify(form))
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: `操作成功`,
              type: "success",
            });
            this.getData();
            this.handleClose();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    orderCreateFileSuccess(res, file) {
      if (res.code == 1) {
        this.orderCreateForm.files.push(res.data);
      } else {
        this.$message({
          message: res.errorMsg,
          type: "danger",
        });
      }
    },
    orderCreateFileUpload() {},
    orderCreateImageSuccess(res, file) {
      this.orderCreateForm.images.push(res.data);
    },
    orderCreateImageUpload() {},
    deleteImg(e) {
      this.orderCreateForm.images.splice(e, 1);
    },
    deleteFile(e) {
      this.orderCreateForm.files.splice(e, 1);
    },
    xiazai(e) {
      const a = document.createElement("a"); // 创建一个HTML 元素
      let url = this.orderCreateForm.files[e];
      a.setAttribute("download", ""); //download属性
      a.setAttribute("href", url); // href链接
      a.click();
    },
    // 删除放款信息————————————————————————————————————————————————————————————————————
    deleteData(e) {
      this.$confirm(`确定删除该放款信息吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: e.id,
          };
          this.$axios
            .post("/api/loan_information/del", this.$qs.stringify(params))
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getData();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    deleteData2(e) {
      this.deleteDataForm.id = e.id;
      this.deleteDataShow = true;
    },
    deleteDataSubmit() {
      if (!this.deleteDataForm.pwd) {
        this.$message({
          message: "请输入密码",
          type: "danger",
        });
        return;
      }
      let params = {
        id: this.deleteDataForm.id,
        pwd: this.deleteDataForm.pwd,
      };
      this.$axios
        .post("/api/loan_information/managerDel", this.$qs.stringify(params))
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getData();
            this.deleteDataShow = false;
            this.deleteDataForm.pwd = "";
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 查看提醒记录——————————————————————————————————————————————————————
    remindLog(e) {
      this.$axios
        .post(
          "/api/loan_information/remindLog",
          this.$qs.stringify({ id: e.id }),
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.remindLogList = res.data.data;
            this.remindLogShow = true;
          }
        });
    },
    // 提醒————————————————————————————————————————————————————————————
    remind(e, index) {
      this.$confirm(`确认已完成${index == 1 ? "还款" : "到期"}提醒?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: e.id,
          };
          console.log(index);
          if (index == 1) {
            this.$axios
              .post(
                "/api/loan_information/repaymentRemind",
                this.$qs.stringify(params),
              )
              .then((res) => {
                if (res.data.code == 1) {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.getData();
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          } else {
            this.$axios
              .post(
                "/api/loan_information/dueRemind",
                this.$qs.stringify(params),
              )
              .then((res) => {
                if (res.data.code == 1) {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.getData();
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          }
        })
        .catch(() => {});
    },
    // 添加放款信息————————————————————————————————————————————————————————
    viewDetailAddSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/loan_information/add", this.$qs.stringify(this.detail))
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getData();
                this.handleClose();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑放款信息————————————————————————————————————————————————————————
    viewDetailSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/loan_information/edit", this.$qs.stringify(this.detail))
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getData();
                this.handleClose();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    viewDetail(e, index) {
      this.$axios
        .post("/api/loan_information/getInfo", this.$qs.stringify({ id: e.id }))
        .then((res) => {
          if (res.data.code == 1) {
            this.detail = res.data.data;
            this.viewDetailShow = true;
            this.viewDetailType = index;
          }
        });
    },
    // 设置贷后管理人员————————————————————————————————————————————————————————
    setManagerSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              "/api/loan_information/setManager",
              this.$qs.stringify(this.form),
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getData();
                this.handleClose();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    setManager(e) {
      this.form.id = e.id;
      this.setManagerShow = true;
    },
    handleClose() {
      this.setManagerShow = false;
      this.viewDetailShow = false;
      this.viewDetailType = false;
      this.remindLogList = [];
      this.remindLogShow = false;
      ((this.orderCreateShow = false),
        (this.orderCreateType = false),
        (this.viewDetailAddShow = false));
      this.deleteDataShow = false;
      this.followUpShow = false;
      this.followUpListShow = false;
      this.deleteDataForm.pwd = "";
      ((this.detailAdd = {
        loanOrderNo: "",
        loanType: "",
        loanCompany: "",
        money: "",
        howLong: "",
        yearInterest: "",
        monthInterest: "",
        repaymentType: "",
        getDay: "",
        repaymentDay: "",
        dueDate: "",
      }),
        (this.form = {
          id: "",
          managerId: "",
        }));
    },
    // 查询列表————————————————————————————————————————————————————————
    derive() {
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.searchData.name,
        tel: this.searchData.tel,
        managerAdminId: this.searchData.managerAdminId,
        loanType: this.searchData.loanType,
        needRepayment: this.searchData.needRepayment || "-1",
        needDue: this.searchData.needDue || "-1",
        isExport: 1,
        endGetDay: this.searchData.endGetDay || "",
        startGetDay: this.searchData.startGetDay || "",
        followUpTimes: this.searchData.followUpTimes || "",
        intentionLevel: this.searchData.intentionLevel || "",
      };
      this.$axios
        .post("/api/loan_information/getList", this.$qs.stringify(params))
        .then((res) => {
          if (res.data.code == 1) {
            const a = document.createElement("a"); // 创建一个HTML 元素
            let url = res.data.data;
            a.setAttribute("download", ""); //download属性
            a.setAttribute("href", url); // href链接
            a.click();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getRowKeys(row) {
      return row.id;
    },
    handleSelectionChange(e) {
      this.ids = [];
      for (let i = 0; i < e.length; i++) {
        this.ids.push(e[i].id);
      }
    },
    handleCurrentChange(e) {
      this.page = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getData();
    },
    refresh() {
      this.page = 1;
      this.getData();
    },
    getData() {
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.searchData.name,
        tel: this.searchData.tel,
        managerAdminId: this.searchData.managerAdminId,
        loanType: this.searchData.loanType,
        needRepayment: this.searchData.needRepayment || "-1",
        needDue: this.searchData.needDue || "-1",
        endGetDay: this.searchData.endGetDay || "",
        startGetDay: this.searchData.startGetDay || "",
        followUpTimes: this.searchData.followUpTimes || "",
        intentionLevel: this.searchData.intentionLevel || "",
      };
      this.$axios
        .post("/api/loan_information/getList", this.$qs.stringify(params))
        .then((res) => {
          this.list = res.data.data;
        });
    },
  },

  mounted() {
    this.getData();
    this.$axios.post("/api/loan_information/allManager").then((res) => {
      this.allManagerList = res.data.data;
    });
    this.token = Cookie.get("token");
    this.accountType = Cookie.get("roleType");
  },
};
</script>
<style lang="scss" scoped>
.tableClass ::v-deep .classRed {
  color: red;
}
.el-button--mini {
  margin-top: 10px;
  margin-left: 0 !important;
}
.flex {
  display: flex;
  align-items: center;
  img {
    width: 100px;
    height: 100px;
    margin-right: 50px;
  }
}
.avatar-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.baiduQueue {
  width: calc(100% - 40px);
  padding: 20px 0;
  min-height: 680px;
  .userNumber {
    width: 90%;
    height: 30px;
    margin: 0 auto;
    text-align: left;
    overflow: hidden;
    & > div {
      font-size: 12px;
      color: gray;
      margin-top: 10px;
      span {
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
  .fromClass2 {
    width: 90%;
    height: auto;
    margin: 10px auto;
    padding: 10px 0;
    display: flex;

    align-content: center;
  }
  .tableClass {
    width: 90%;
    margin: 0 auto;
  }
  //   .el-dialog__body{
  //       padding: 10px 20px;
  //       display: flex;
  //       justify-content: center;
  //       align-items: center;
  //   }
}
.btn {
  width: 90%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.initializeTitle {
  font-size: 14px;
  color: gray;
}
.el-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.el-dialog__body {
  padding: 20px;
}
.hidden {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  height: 23px !important;
}
.tableImg {
  width: 34px;
  height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/pages/informationList/index.vue